import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { cartService } from 'services';
import { UpdateLineItemQuantityParams } from 'types';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';
import { AxiosError } from 'axios';

export const useUpdateLineItemQuantity = () => {
  const i18n = useI18n();
  const queryClient = useQueryClient();
  return useMutation(
    ({
      lineItemId,
      quantity,
      isRewardPointSelected,
    }: UpdateLineItemQuantityParams) => {
      return cartService.setLineItemQuantity(
        lineItemId,
        quantity,
        isRewardPointSelected
      );
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Item quantity successfully updated.']);
        queryClient.setQueriesData([ServerStateKeysEnum.userCurrentCart], data);
      },
      onError: (err: AxiosError<{ error: string }>) => {
        if (err.response?.status !== 422) {
          displayNotification(
            i18n['Failed to update lineitem quantity!'],
            'danger'
          );
        }
      },
    }
  );
};
